import React from 'react';
import cn from 'classnames';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
import withScriptjs from "react-google-maps/lib/async/withScriptjs";
import styles from './MapStyles';

import Listing from 'components/common/Listing';

const MapWithLoader = withScriptjs(withGoogleMap(({ markers, onMarkerClick, onMapClick }) => {
  const markerComps = markers && markers.map((marker, i) => {
    const icon = marker.active ? 'map_pin_hovered' : 'map_pin_default';
    return <Marker key={i} position={marker.position}
                   onClick={() => onMarkerClick(marker)}
                   icon={require(`icons/${icon}.svg`)}>
      { marker.showInfo && (
        <InfoWindow onCloseClick={() => console.log("close", marker.listing)}>
          <div style={{width: 280}}>
            <Listing {...marker.listing} small={true}/>
          </div>
        </InfoWindow>
      )}
    </Marker>
  });

  const center = markers && markers.length ? markers[0].position : undefined;

  return (
    <GoogleMap defaultZoom={12} defaultCenter={center} options={{scrollwheel: false, styles, disableDefaultUI: true, zoomControl: true}} onClick={onMapClick}>
      { markerComps }
    </GoogleMap>
  );
}));

export default class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      markers: props.markers
    };
  }

  componentWillReceiveProps(nextProps) {
    // TODO: should we preserve showInfo ? (functional question)
    if (nextProps.markers) this.setState({
      markers: nextProps.markers
    });
  }

  onMarkerClick(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        const active = marker === targetMarker;
        return {
          ...marker,
          showInfo: active,
          active
        }
      })
    })
  }

  onMapClick() {
    this.setState({
      markers: this.state.markers.map(marker => {
        return {
          ...marker,
          showInfo: false,
          active: false
        };
      })
    });
  }

  onMarkerClick = this.onMarkerClick.bind(this);
  onMapClick = this.onMapClick.bind(this);

  render() {
    return (
      <MapWithLoader
        loadingElement={<div/>}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`}
        containerElement={<div className={cn("map-container", this.props.className)}/>}
        mapElement={<div className="map-el"/>}
        markers={this.state.markers}
        onMarkerClick={this.onMarkerClick}
        onMapClick={this.onMapClick}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/common/Map.js